import { render, staticRenderFns } from "./ReportCrime.vue?vue&type=template&id=8533bca6&scoped=true"
import script from "./ReportCrime.vue?vue&type=script&lang=js"
export * from "./ReportCrime.vue?vue&type=script&lang=js"
import style0 from "./ReportCrime.vue?vue&type=style&index=0&id=8533bca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8533bca6",
  null
  
)

export default component.exports